import {
  TaxonomyTheme,
} from '../implementations';


const mappers = {
  themes: TaxonomyTheme,
};

export default mappers;
